(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-handoff"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /**
     * base64url decode — UTF-8 safe via TextEncoder/TextDecoder.
     * Mirrors the planner's `apps/web/lib/design-state.ts` helper.
     * Returns null on any failure; never throws.
     */
    function base64UrlDecode(s) {
      try {
        var pad = (4 - (s.length % 4)) % 4;
        if (pad === 3) return null;
        var padded = s.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat(pad);
        var binary = atob(padded);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      } catch (e) {
        return null;
      }
    }

    /**
     * Resolve a LineItem to a Shopify variant ID. Dual-shape (July
     * 2026 catalogue wave):
     *
     *   NEW SHAPE — `item.variantFinish` present (baked in by the
     *   planner's catalogue at generation time): the product is
     *   variant-per-profile×finish; match the variant by its exact
     *   option strings ("Profile / Finish" title, with an
     *   option1/option2 fallback for robustness). Colour rides in
     *   line-item properties, never in the variant.
     *
     *   OLD SHAPE — no variant fields: colour-substring match as
     *   before, then "Default Title".
     *
     * The historical `variants[0]` last-resort fallback is REMOVED
     * (Mat, 2026-08-11): a silently-wrong variant is a remake + a
     * refund; an unresolved item is a support conversation. Unresolved
     * items surface via the designer-review panel — the customer sees
     * which pieces failed and proceeds with the rest.
     *
     * Returns null on 404 / network failure / no matching variant.
     */
    function getVariantId(item) {
      return fetch('/products/' + item.handle + '.json')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (!data.product || !data.product.variants) return null;
          var variants = data.product.variants;
          var match = null;
          if (item.variantFinish) {
            var wanted =
              (item.variantProfile || '') + ' / ' + item.variantFinish;
            match = variants.find(function (v) {
              return v.title === wanted;
            });
            if (!match) {
              match = variants.find(function (v) {
                return (
                  v.option1 === item.variantProfile &&
                  v.option2 === item.variantFinish
                );
              });
            }
          } else {
            if (item.colour) {
              match = variants.find(function (v) {
                return (
                  v.title.toLowerCase().indexOf(item.colour.toLowerCase()) !==
                  -1
                );
              });
            }
            if (!match) {
              match = variants.find(function (v) {
                return v.title === 'Default Title';
              });
            }
          }
          return match ? String(match.id) : null;
        })
        .catch(function () {
          return null;
        });
    }

    /**
     * Build a Shopify cart-line `{id, quantity, properties}` from a
     * single LineItem by resolving its handle to a variant ID.
     * Returns null if the variant can't be resolved (handle drift,
     * 404, network error). The caller filters nulls before posting.
     */
    function buildCartLine(item) {
      return getVariantId(item).then(function (variantId) {
        if (!variantId) return { line: null, item: item };
        return {
          line: {
            id: parseInt(variantId, 10),
            quantity: item.quantity,
            properties: item.properties || {}
          },
          item: item
        };
      });
    }

    /**
     * POST resolved cart lines to /cart/add.js. Tries batch first
     * (atomic, fast happy path); on batch failure falls back to
     * per-item POSTs so partial success is still possible.
     * Resolves to `{ ok, added, refused }` - `ok` is true iff at least
     * one item landed in the cart. Ported from ikea-builder.js:589-614.
     *
     * REFUSED LINES ARE NAMED, NEVER DROPPED (Mat, 2026-09-25: "a line
     * Shopify refuses currently vanishes from the cart without telling
     * anyone"). Every line the shop turns down in the per-item pass
     * comes back in `refused` with a plain-English reason, and the
     * caller puts it in the "needs a hand" panel.
     */
    function refusalReason(status, description) {
      var d = String(description || '');
      if (
        status === 422 &&
        /sold out|out of stock|only add|can't add|cannot add|can not add|not available|unavailable/i.test(d)
      ) {
        return 'Not in stock in our shop right now, so it could not go in your cart.';
      }
      if (status === 422 && d) {
        return 'Our shop would not add it. It said: "' + d + '"';
      }
      return 'Our shop did not answer when we tried to add it, so it is not in your cart.';
    }

    function postCartLines(entries) {
      var lines = entries.map(function (e) {
        return e.line;
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (res) {
          if (res && res.ok) {
            return { ok: true, added: lines.length, refused: [] };
          }
          // Per-item fallback: add what the shop takes, name what it
          // refuses.
          return Promise.all(
            entries.map(function (entry) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [entry.line] })
              })
                .then(function (r) {
                  if (r.ok) return { added: true };
                  return r
                    .json()
                    .catch(function () {
                      return {};
                    })
                    .then(function (body) {
                      var said = (body && (body.description || body.message)) || '';
                      return {
                        added: false,
                        reason: refusalReason(r.status, said),
                        shop: typeof said === 'string' ? said : ''
                      };
                    });
                })
                .catch(function () {
                  return { added: false, reason: refusalReason(0, ''), shop: '' };
                });
            })
          ).then(function (results) {
            var added = 0;
            var refused = [];
            for (var ri = 0; ri < results.length; ri++) {
              if (results[ri].added) {
                added++;
              } else {
                refused.push({
                  item: entries[ri].item,
                  reason: results[ri].reason,
                  shop: results[ri].shop || ''
                });
              }
            }
            return { ok: added > 0, added: added, refused: refused };
          });
        })
        .catch(function () {
          return { ok: false, added: 0, refused: [] };
        });
    }

    /**
     * Top-level cart-add. Filters bad inputs, resolves all variants
     * in parallel, posts the resolved lines, returns `{ ok, added }`.
     * Pure async logic — no DOM access. Caller (init) handles the
     * UI dispatch on resolve / reject.
     *
     * TODO(piece 6): on partial-fail (some items resolved + posted
     * but some failed), set `sessionStorage.ib_cart_warning` for a
     * cart-page banner. Skipped in v1 — no live-theme reader exists
     * for that key yet (legacy banner lives in the ikea-cart-
     * builder Theme App Extension's bundle, not theme files).
     */
    function addAllToCart(items) {
      var validInputs = items.filter(function (item) {
        return item && item.handle && (item.quantity || 0) > 0;
      });
      if (validInputs.length === 0) {
        return Promise.resolve({ ok: false, added: 0, unresolved: [] });
      }
      return Promise.all(validInputs.map(buildCartLine)).then(function (
        results
      ) {
        var validLines = [];
        var unresolved = [];
        for (var i = 0; i < results.length; i++) {
          if (results[i].line !== null) {
            validLines.push(results[i]);
          } else {
            unresolved.push(results[i].item);
          }
        }
        if (validLines.length === 0) {
          return { ok: false, added: 0, unresolved: unresolved };
        }
        return postCartLines(validLines).then(function (post) {
          post.unresolved = unresolved;
          return post;
        });
      });
    }

    /**
     * Production planner origin. Used for:
     *   - the `cart-payload` fetch URL (below)
     *   - origin-validating any `plannerUrl` we receive from the
     *     stash payload OR re-hydrate from sessionStorage (defence
     *     against tampered storage / malformed payloads)
     *   - the hardcoded `PLANNER_SHOWROOM_URL` fallback for the Back
     *     button when no live planner URL is available
     */
    var PLANNER_ORIGIN = 'https://planner.customea.com.au';

    /**
     * URL for the planner's cart-payload endpoint. Stash stores the
     * customer's LineItem[] keyed by token (1-hour TTL); this fetches
     * by token. Hardcoded to the production planner deployment —
     * staging-preview tests would need to override this temporarily
     * if testing against a planner branch deploy.
     */
    var CART_PAYLOAD_URL = PLANNER_ORIGIN + '/api/cart-payload';

    /**
     * Day 11 Phase 3.5 — Back-to-planner fallback chain destination.
     * When the customer's actual planner URL isn't available (token
     * expired, no payload fetch yet, sessionStorage empty, etc.),
     * the back button lands them on the showroom. Better than
     * `history.back()` which used to send them to /cart after the
     * Continue-to-cart round-trip.
     */
    var PLANNER_SHOWROOM_URL = PLANNER_ORIGIN + '/ikea-import?showroom=true';

    /**
     * sessionStorage key for the customer's planner URL. Captured on
     * the first successful payload fetch so subsequent loads
     * (refresh, browser-back from /cart) still know where to send
     * the customer if Back to planner is clicked. Tab-scoped is
     * fine — cart-handoff is single-tab per session.
     */
    var SESSION_STORAGE_KEY_PLANNER_URL = 'cartHandoffPlannerUrl';

    /**
     * Origin-validate a planner URL before storing or navigating to
     * it. Defensive against malformed payloads / tampered
     * sessionStorage values. Returns true iff `url` parses cleanly
     * AND its origin equals the production planner.
     */
    function isValidPlannerOrigin(url) {
      if (typeof url !== 'string' || url.length === 0) return false;
      try {
        return new URL(url).origin === PLANNER_ORIGIN;
      } catch (e) {
        return false;
      }
    }

    /**
     * Fetch a stashed payload from the planner's cart-payload
     * endpoint. Resolves to `{ items, plannerUrl }`:
     *   - `items`: the LineItem[] (validated as array at the boundary)
     *   - `plannerUrl`: the customer's planner page URL (string) if
     *     the planner emitted one in the POST, OR null. Used by the
     *     "Back to planner" fallback chain to land them at their
     *     exact design state. Day 11 Phase 3.5 forward-compat — if
     *     planner hasn't deployed the plannerUrl emit yet, payload
     *     returns `plannerUrl: undefined`, this normalises to null,
     *     back button falls through to showroom URL.
     *
     * Rejects with an error carrying `code` for the `init()` dispatcher:
     *   - 404 → `{ code: 'EXPIRED' }` (token TTL'd or never existed)
     *   - other non-2xx / network fail / malformed body → `{ code:
     *     'FETCH_FAILED' }`
     *
     * Every rejection also carries `reason` — a short support code
     * shown to the customer on the error page and quoted back to us.
     * Sources, in order of preference:
     *   - the planner's own machine code lifted from the error body
     *     (INVALID_PLANNER_URL / RATE_LIMITED / STASH_UNAVAILABLE /
     *     STASH_WRITE_FAILED / TOO_MANY_ITEMS / …) so both sides of
     *     the handoff quote the same vocabulary
     *   - `http-<status>` when the body carries no usable code
     *   - `network` when the request never reached the planner at all
     *     (offline, DNS, or a refused CORS preflight — the exact
     *     failure mode of the old vercel.app origin, whose preflight
     *     308-redirected and so never returned CORS headers)
     *   - `bad-response` for a 2xx whose body isn't a payload
     *
     * Validates the response shape at the boundary — planner-side
     * `cart-payload` returns `{ items: array, plannerUrl?: string }`;
     * anything else is treated as fetch-failed.
     */
    /**
     * Lift the planner's own machine code out of a non-2xx error body.
     * Deliberately strict: only a SHOUTY_SNAKE token is accepted, so
     * server prose, stack traces, HTML error pages and anything that
     * could carry customer data never reach the page. Returns null
     * when there's nothing safe to surface — callers fall back to
     * `http-<status>`.
     */
    function plannerErrorCode(body) {
      if (typeof body !== 'string' || body.length === 0 || body.length > 2000) {
        return null;
      }
      var parsed;
      try {
        parsed = JSON.parse(body);
      } catch (e) {
        return null;
      }
      if (!parsed || typeof parsed !== 'object') return null;
      var candidate = null;
      if (typeof parsed.code === 'string') candidate = parsed.code;
      else if (typeof parsed.error === 'string') candidate = parsed.error;
      else if (typeof parsed.reason === 'string') candidate = parsed.reason;
      if (!candidate || !/^[A-Z][A-Z0-9_]{1,39}$/.test(candidate)) return null;
      return candidate;
    }

    function stashHttpError(status, body) {
      var err = new Error('Stash fetch failed: ' + status);
      err.code = 'FETCH_FAILED';
      err.reason = plannerErrorCode(body) || 'http-' + status;
      return err;
    }

    function fetchFromStash(token) {
      var url = CART_PAYLOAD_URL + '?token=' + encodeURIComponent(token);
      return fetch(url, { method: 'GET', credentials: 'omit' }).then(
        function (r) {
          if (r.status === 404) {
            var expired = new Error('Token expired or not found');
            expired.code = 'EXPIRED';
            expired.reason = 'http-404';
            throw expired;
          }
          if (!r.ok) {
            // Read the body so a planner-issued code (RATE_LIMITED,
            // STASH_UNAVAILABLE, …) can be quoted verbatim; if the
            // body can't be read at all, fall back to the status.
            return r.text().then(
              function (body) {
                throw stashHttpError(r.status, body);
              },
              function () {
                throw stashHttpError(r.status, '');
              }
            );
          }
          return r.text().then(function (body) {
            var data = null;
            try {
              data = JSON.parse(body);
            } catch (e) {
              data = null;
            }
            if (!data || !Array.isArray(data.items)) {
              var shapeErr = new Error('Stash returned malformed payload');
              shapeErr.code = 'FETCH_FAILED';
              shapeErr.reason = 'bad-response';
              throw shapeErr;
            }
            var plannerUrl =
              typeof data.plannerUrl === 'string' && data.plannerUrl.length > 0
                ? data.plannerUrl
                : null;
            // PLAN NOTE (2026-09-13). The planner's review modal lets the
            // customer type one note for the whole order; the stash
            // carries it as `note` and it becomes the CART NOTE below, so
            // it lands on the Shopify order as `order.note` — the field
            // the ERP already reads (Admin, packing slip, freight labels).
            // Absent or empty normalises to null; nothing here depends on
            // it being present.
            var note =
              typeof data.note === 'string' && data.note.trim().length > 0
                ? data.note.trim().slice(0, 600)
                : null;
            return { items: data.items, plannerUrl: plannerUrl, note: note };
          });
        },
        function () {
          // Rejection handler bound to the fetch itself, not to the
          // response handler above — so this fires only when the
          // request never completed: offline, DNS, or a refused CORS
          // preflight. Errors thrown while handling a real response
          // keep their own reason.
          var netErr = new Error('Stash fetch never reached the planner');
          netErr.code = 'FETCH_FAILED';
          netErr.reason = 'network';
          throw netErr;
        }
      );
    }

    function decodeItems(raw) {
      if (!raw) return null;
      var json = base64UrlDecode(raw);
      if (json === null) return null;
      var parsed;
      try {
        parsed = JSON.parse(json);
      } catch (e) {
        return null;
      }
      // Bare LineItem[] — canonical planner emit.
      if (Array.isArray(parsed)) return parsed;
      // Wrapper {items: [...]} — future-proof if the planner ever
      // graduates to a versioned wrapper format.
      if (parsed && typeof parsed === 'object' && Array.isArray(parsed.items)) {
        return parsed.items;
      }
      // Object without items array — diagnostic payload (e.g. {"v":1}).
      // Treat as valid-but-empty cart instead of malformed-link error.
      if (parsed && typeof parsed === 'object') return [];
      // Primitive JSON (string, number, boolean, null) — genuine reject.
      return null;
    }

    function init() {
      var statusEl = document.querySelector('[data-cart-handoff-status]');
      var countEl = document.querySelector('[data-cart-handoff-count]');
      var nounEl = document.querySelector('[data-cart-handoff-noun]');
      var errorEl = document.querySelector('[data-cart-handoff-error]');
      var ctaEl = document.querySelector('[data-cart-handoff-cta]');
      var termsEl = document.querySelector('[data-cart-handoff-terms-block]');
      var footerEl = document.querySelector('[data-cart-handoff-footer]');

      /**
       * PLANNER HANDOFF TERMS. Accepted by clicking "Continue to cart"
       * (2026-09-25; it was a tick box from 2026-09-19). The acceptance
       * is written to the cart as an attribute so it lands on the
       * order, at the same two points the tick used: the moment of the
       * click (best effort, the cart may still be empty) and again with
       * the note once the lines are in, which is the write that
       * reliably reaches the order.
       */
      var TERMS_ATTRIBUTE_KEY = 'Planner handoff terms';
      // The version comes from the markup: this {% javascript %} block is
      // a static asset, Liquid does not run inside it.
      var TERMS_ATTRIBUTE_VALUE =
        'Accepted, version ' +
        ((termsEl && termsEl.getAttribute('data-cart-handoff-terms-version')) || '2026-09-22');
      function termsAttributes() {
        var a = {};
        a[TERMS_ATTRIBUTE_KEY] = TERMS_ATTRIBUTE_VALUE;
        return a;
      }
      function writeTermsAcceptance() {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: termsAttributes() })
        }).catch(function () {});
      }
      var plannerTermsToggle = document.querySelector('[data-cart-handoff-planner-terms]');
      var plannerTermsPanel = document.getElementById('cart-handoff-planner-terms');
      if (plannerTermsToggle && plannerTermsPanel) {
        plannerTermsToggle.addEventListener('click', function (ev) {
          ev.preventDefault();
          var open = plannerTermsPanel.hidden;
          plannerTermsPanel.hidden = !open;
          plannerTermsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      var retryEl = document.querySelector('[data-cart-handoff-retry]');
      var sectionEl =
        document.querySelector('.cart-handoff[data-cart-handoff-state]') ||
        document.querySelector('.cart-handoff');
      // Back-to-planner buttons are wired below via `querySelectorAll`
      // so each error variant's own button works. No single `backEl`
      // ref needed.

      /**
       * The ONLY way anything on this page changes what is visible.
       * Writes one attribute; the stylesheet's single-state rule does
       * the rest, so the loading / ready / error / review blocks are
       * mutually exclusive by construction. Do not add `.hidden`
       * toggles for those four blocks — a second mechanism is exactly
       * how the error copy and the success copy ended up on screen
       * together.
       *
       * (`hidden` is still correct INSIDE a state: the error variants
       * and the "quote this code" line are sub-parts of `error`.)
       */
      function setState(name) {
        if (sectionEl) sectionEl.setAttribute('data-cart-handoff-state', name);
      }

      /**
       * Show one of the error-block variants (`malformed` /
       * `cart-failed` / `expired`) and reveal the error block. Hides
       * the others.
       *
       * `reason` is an optional short support code (see
       * `fetchFromStash`). When present it renders the "quote this
       * code" line next to the contact link on the malformed variant,
       * so the customer has both a reason and a way to reach us.
       * Absent or non-string → the line stays hidden rather than
       * showing an empty or invented code.
       */
      function showErrorVariant(name, reason) {
        if (!errorEl) return;
        var variants = errorEl.querySelectorAll(
          '[data-cart-handoff-error-variant]'
        );
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          v.hidden = v.getAttribute('data-cart-handoff-error-variant') !== name;
        }
        var codeWrap = errorEl.querySelector('[data-cart-handoff-error-code]');
        var codeEl = errorEl.querySelector('[data-cart-handoff-code]');
        if (codeWrap && codeEl) {
          if (typeof reason === 'string' && reason.length > 0) {
            codeEl.textContent = reason;
            codeWrap.hidden = false;
          } else {
            codeEl.textContent = '';
            codeWrap.hidden = true;
          }
        }
        setState('error');
      }

      /**
       * Cart-add failed terminally. Hide status panel + CTA + footer,
       * show the cart-failed error variant. Customer interacts via the
       * retry / back buttons inside the error block.
       */
      function showCartFailedError() {
        showErrorVariant('cart-failed');
      }

      /**
       * Reset the page to its decoded-and-ready state after a cart-
       * add failure (used by the retry button). Hides the error block,
       * re-shows status + CTA + footer, re-enables CTA.
       */
      function resetToReadyState() {
        if (ctaEl) ctaEl.disabled = false;
        setState('ready');
      }

      /**
       * Day 11 Phase 3.5 — Back-to-planner fallback chain. Replaces
       * the old `document.referrer` / `history.back()` heuristic
       * which silently broke for the customer recovery flow:
       *   planner → cart-handoff → /cart → browser-back to cart-
       *   handoff → click Back → ❌ goes to /cart, not planner.
       *
       * New chain (in order):
       *   1. `currentPlannerUrl` — captured this session from the
       *      stash payload's `plannerUrl` field.
       *   2. sessionStorage value — re-hydrated on page load (handles
       *      refresh + browser-back-from-/cart cases where the
       *      payload fetch already happened earlier in the session).
       *   3. `PLANNER_SHOWROOM_URL` — hardcoded final fallback.
       *
       * Origin-validation at every step guards against tampered
       * sessionStorage / malformed payload values.
       */
      var currentPlannerUrl = null;
      // The plan note from the stash payload, or null. Set in
      // `proceed()`, read once in `handleCartAdd()`.
      var currentNote = null;
      try {
        var stored = sessionStorage.getItem(SESSION_STORAGE_KEY_PLANNER_URL);
        if (stored && isValidPlannerOrigin(stored)) {
          currentPlannerUrl = stored;
        }
      } catch (e) {
        // sessionStorage may throw in private-browse modes — fall
        // through to the showroom URL via resolveBackUrl().
      }

      function resolveBackUrl() {
        if (currentPlannerUrl && isValidPlannerOrigin(currentPlannerUrl)) {
          return currentPlannerUrl;
        }
        return PLANNER_SHOWROOM_URL;
      }

      var backEls = document.querySelectorAll('[data-cart-handoff-back]');
      for (var bi = 0; bi < backEls.length; bi++) {
        backEls[bi].addEventListener('click', function () {
          window.location.href = resolveBackUrl();
        });
      }

      /**
       * Items array is in hand (from either `?token=` stash fetch or
       * `?items=` direct decode). Populate the UI and wire the CTA +
       * retry buttons. Identical end-state regardless of which path
       * delivered the items.
       *
       * `plannerUrl` is the optional second argument from the token
       * path (legacy items path passes null). When present + origin-
       * valid, captured into the closure variable so the back button
       * can navigate to it, AND persisted to sessionStorage so a
       * subsequent page load (refresh / back-from-/cart) still has
       * the URL even if the token has expired by then.
       */
      function proceed(items, plannerUrl, note) {
        currentNote = typeof note === 'string' && note.length > 0 ? note : null;
        if (plannerUrl && isValidPlannerOrigin(plannerUrl)) {
          currentPlannerUrl = plannerUrl;
          try {
            sessionStorage.setItem(
              SESSION_STORAGE_KEY_PLANNER_URL,
              plannerUrl
            );
          } catch (e) {
            // sessionStorage write failed (private-browse, quota,
            // disabled storage) — closure variable still set, back
            // button works for this session at least.
          }
        }

        // eslint-disable-next-line no-console
        console.log('[cart-handoff] LineItems:', items);

        /* ⛔ THE COUNT IS ITEMS, NOT ROWS (Mat, 2026-09-28): "117 items
           ready for your cart, and the number counts items, not lines."
           The planner now merges identical products onto one line
           carrying the total quantity, so items.length is a count of
           ROWS and no longer a count of what the customer is buying. The
           word changed to "items", and the number had to change with it,
           or a row count would be sitting behind the word items.
           A missing or unusable quantity counts as one rather than
           dropping the row out of the total. */
        var count = items.reduce(function (sum, it) {
          var q = Number(it && it.quantity);
          return sum + (isFinite(q) && q > 0 ? q : 1);
        }, 0);
        if (countEl) countEl.textContent = String(count);
        if (nounEl) {
          nounEl.textContent =
            count === 1 ? 'item ready for your cart' : 'items ready for your cart';
        }
        if (statusEl) statusEl.classList.add('cart-handoff__status--ready');
        // Items are in hand — this is the one place the success state
        // is entered, and entering it retires any error on screen.
        setState('ready');

        /**
         * CTA click handler — disable button, run cart-add, dispatch
         * on result. On success (any items added), redirect to /cart
         * so Shopify's standard cart page renders the line items +
         * total. On total failure, show the cart-failed error variant
         * and leave the customer the retry / back affordances.
         */
        /**
         * WS1-E — unresolved-items surfacing (designer-review flag
         * pattern). Shown instead of the silent redirect when one or
         * more items couldn't resolve to a variant (the variants[0]
         * fallback is gone). Lists the affected item titles; the
         * customer proceeds to /cart with everything that DID add
         * (Continue button, shown only when added > 0).
         */
        function showUnresolvedPanel(result) {
          var panel = document.querySelector('[data-cart-handoff-unresolved]');
          if (!panel) {
            // Markup missing (partial deploy) — degrade to the old
            // behaviour rather than stranding the customer.
            if (result.ok) window.location.href = '/cart';
            else showCartFailedError();
            return;
          }
          var listEl = panel.querySelector(
            '[data-cart-handoff-unresolved-list]'
          );
          var refused = result.refused || [];
          if (listEl) {
            listEl.textContent = '';
            for (var ui = 0; ui < result.unresolved.length; ui++) {
              var li = document.createElement('li');
              li.textContent =
                result.unresolved[ui].title || result.unresolved[ui].handle;
              listEl.appendChild(li);
            }
            for (var fi = 0; fi < refused.length; fi++) {
              var rli = document.createElement('li');
              var rname = document.createElement('span');
              rname.className = 'cart-handoff__review-name';
              rname.textContent =
                refused[fi].item.title || refused[fi].item.handle;
              var rwhy = document.createElement('span');
              rwhy.className = 'cart-handoff__review-reason';
              rwhy.textContent = refused[fi].reason;
              rli.appendChild(rname);
              rli.appendChild(rwhy);
              listEl.appendChild(rli);
            }
          }
          var titleEl = panel.querySelector(
            '[data-cart-handoff-unresolved-title]'
          );
          var noteEl = panel.querySelector(
            '[data-cart-handoff-unresolved-note]'
          );
          var continueEl = panel.querySelector('[data-cart-handoff-continue]');
          var n = result.unresolved.length + refused.length;
          // A refused line needs the customer to act, so the note says
          // what to do and links the contact page.
          function refusedNote(lead) {
            if (!noteEl) return;
            noteEl.textContent = lead + ' ';
            var a = document.createElement('a');
            a.href = '/pages/contact-us';
            a.textContent = 'contact us';
            noteEl.appendChild(a);
            noteEl.appendChild(
              document.createTextNode(
                ' and we will add ' +
                  (n === 1 ? 'it' : 'them') +
                  ' to your order or suggest an alternative.'
              )
            );
          }
          if (result.added > 0) {
            if (titleEl) {
              titleEl.textContent =
                n === 1
                  ? '1 item needs a hand from our design team'
                  : n + ' items need a hand from our design team';
            }
            if (refused.length > 0) {
              refusedNote('Everything else is in your cart. Before you check out,');
            } else if (noteEl) {
              noteEl.textContent =
                'Our design team will confirm these with you — everything ' +
                'else has been added to your cart.';
            }
            if (continueEl) {
              continueEl.hidden = false;
              continueEl.addEventListener('click', function () {
                // Some items added: the note still belongs on the order.
                setCartNote(currentNote).then(function () {
                  window.location.href = '/cart';
                });
              });
            }
          } else {
            if (titleEl) {
              titleEl.textContent = "We couldn't add these items";
            }
            if (refused.length > 0) {
              refusedNote('Nothing is in your cart yet. Try again in a minute, or');
            } else if (noteEl) {
              noteEl.textContent =
                'None of your items could be matched to our product range ' +
                'just now. Head back to the planner and try again, or get ' +
                'in touch and our design team will sort it with you.';
            }
          }
          setState('review');
        }

        /**
         * PLAN NOTE -> CART NOTE (2026-09-13). One POST to /cart/update.js
         * after the lines are in, so Shopify carries the customer's note
         * onto the order. Resolves whatever happens: a note that fails to
         * stick must never strand a customer whose items DID add — the
         * redirect to /cart goes ahead either way, and the failure is
         * logged for QA. No-op when there is no note.
         */
        function setCartNote(note) {
          // Terms acceptance rides on the same update as the note
          // (2026-09-19). The attribute is always sent: the only way here
          // is a click on "Continue to cart", which is the acceptance.
          var payload = { attributes: termsAttributes() };
          if (typeof note === 'string' && note.length > 0) {
            payload.note = note;
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (r) {
              if (!r.ok) {
                // eslint-disable-next-line no-console
                console.warn('[cart-handoff] cart note not set:', r.status);
              }
              return Boolean(r.ok);
            })
            .catch(function () {
              // eslint-disable-next-line no-console
              console.warn('[cart-handoff] cart note not set: request failed');
              return false;
            });
        }

        /**
         * THE PANEL TELLS MAT TOO (Mat, 2026-09-25: "If someone hits that
         * panel and does not contact us, we never learn it happened").
         * One fire-and-forget beacon to the planner, which emails Mat
         * through its one alarm path. Lines go by their position in the
         * stash (the planner reads the names back from its own row), with
         * the reason the customer saw and Shopify's own message. Never in
         * the customer's way; nothing to wait on.
         */
        function reportHandoffPanel(result) {
          try {
            if (!token || !navigator.sendBeacon) return;
            var lines = [];
            var un = result.unresolved || [];
            for (var a = 0; a < un.length; a++) {
              var ui2 = items.indexOf(un[a]);
              if (ui2 >= 0) lines.push({ i: ui2, kind: 'unmatched', reason: '', shop: '' });
            }
            var rf = result.refused || [];
            for (var b = 0; b < rf.length; b++) {
              var ri2 = items.indexOf(rf[b].item);
              if (ri2 >= 0) {
                lines.push({ i: ri2, kind: 'refused', reason: rf[b].reason || '', shop: rf[b].shop || '' });
              }
            }
            if (lines.length === 0) return;
            navigator.sendBeacon(
              PLANNER_ORIGIN + '/api/handoff-alarm',
              new Blob(
                [JSON.stringify({ token: token, added: result.added || 0, lines: lines })],
                { type: 'text/plain' }
              )
            );
          } catch (e) {}
        }

        function handleCartAdd() {
          if (!ctaEl) return;
          ctaEl.disabled = true;
          addAllToCart(items)
            .then(function (result) {
              var unresolved = result.unresolved || [];
              var refusedLines = result.refused || [];
              if (result.ok && unresolved.length === 0 && refusedLines.length === 0) {
                // eslint-disable-next-line no-console
                console.log('[cart-handoff] cart-add OK, added', result.added, 'of', count);
                // The note rides only when something was added — a note
                // on an empty cart is a note on nothing.
                setCartNote(currentNote).then(function () {
                  window.location.href = '/cart';
                });
              } else if (unresolved.length > 0 || refusedLines.length > 0) {
                // eslint-disable-next-line no-console
                console.warn(
                  '[cart-handoff] unresolved items:',
                  unresolved.length,
                  'refused:',
                  refusedLines.length,
                  'added:',
                  result.added
                );
                reportHandoffPanel(result);
                showUnresolvedPanel(result);
              } else {
                // eslint-disable-next-line no-console
                console.warn('[cart-handoff] cart-add failed (zero items added)');
                showCartFailedError();
              }
            })
            .catch(function (err) {
              // eslint-disable-next-line no-console
              console.error('[cart-handoff] cart-add threw:', err);
              showCartFailedError();
            });
        }

        if (ctaEl && typeof ctaEl.addEventListener === 'function') {
          ctaEl.disabled = count === 0;
          ctaEl.addEventListener('click', function () {
            // The click IS the acceptance (the terms text sits directly
            // above this button). Recorded now, as the tick used to be,
            // and again with the note once the lines are in.
            writeTermsAcceptance();
            // Funnel point 4, CONTINUE TO CART (Mat, 2026-09-25): a
            // fire-and-forget beacon to the planner, never in the way of
            // the cart. text/plain keeps it a simple request (no preflight).
            try {
              if (token && navigator.sendBeacon) {
                navigator.sendBeacon(
                  PLANNER_ORIGIN + '/api/funnel/continue',
                  new Blob([JSON.stringify({ token: token })], { type: 'text/plain' })
                );
              }
            } catch (e) {}
            handleCartAdd();
          });
        }

        if (retryEl && typeof retryEl.addEventListener === 'function') {
          retryEl.addEventListener('click', function () {
            resetToReadyState();
            handleCartAdd();
          });
        }
      }

      var params = new URLSearchParams(window.location.search);
      var token = params.get('token');
      var rawItems = params.get('items');

      // Dispatch: token path takes precedence over items path. Both
      // paths converge on `proceed(items)` once an items array is in
      // hand. The malformed branch fires when neither path produces
      // items (no params, malformed payload, or token fetch failed).
      if (token) {
        // eslint-disable-next-line no-console
        console.log('[cart-handoff] fetching stash for token', token);
        fetchFromStash(token)
          .then(function (result) {
            proceed(result.items, result.plannerUrl, result.note);
          })
          .catch(function (err) {
            if (err && err.code === 'EXPIRED') {
              showErrorVariant('expired');
              // eslint-disable-next-line no-console
              console.warn('[cart-handoff] token expired or not found:', token);
            } else {
              var reason =
                err && typeof err.reason === 'string' && err.reason.length > 0
                  ? err.reason
                  : 'network';
              showErrorVariant('malformed', reason);
              // eslint-disable-next-line no-console
              console.warn('[cart-handoff] stash fetch failed:', reason, err);
            }
          });
        return;
      }

      if (rawItems !== null) {
        var items = decodeItems(rawItems);
        if (items === null) {
          showErrorVariant('malformed', 'bad-payload');
          // eslint-disable-next-line no-console
          console.warn('[cart-handoff] No / malformed ?items= payload', { raw: rawItems });
          return;
        }
        // Legacy `?items=` path has no plannerUrl — pass null so
        // `proceed` falls through to the sessionStorage / showroom
        // chain when the customer clicks Back. (Pre-Day-10-piece-5c
        // behaviour, kept for backward-compat with in-flight URLs.)
        proceed(items, null);
        return;
      }

      // Neither ?token= nor ?items= present — direct visitor with no
      // payload. Show malformed (treat "no link content" as a broken
      // link from the customer's perspective).
      showErrorVariant('malformed', 'no-token');
    }

    // DOM-readiness gate. Shopify's `{% javascript %}` content is
    // bundled into a section asset that may execute before the section's
    // body markup is parsed (depending on how the theme's <script> tag
    // is positioned and whether it carries `defer`). Defer the queries
    // + wire-up until DOMContentLoaded — or run immediately if the
    // document already finished parsing.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customea-build-my-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  var input = document.getElementById('cta-bmc-file');
  if (!input) return;

  var wrap = input.closest('.cta-bmc__file-wrap');
  var textEl = wrap ? wrap.querySelector('.cta-bmc__file-text') : null;
  if (!textEl) return;

  var defaultText = textEl.getAttribute('data-default') || textEl.textContent;

  input.addEventListener('change', function(e) {
    if (input.files && input.files.length > 0) {
      var name = input.files[0].name;
      // Truncate long filenames
      if (name.length > 38) name = name.substring(0, 35) + '...';
      textEl.textContent = name;
      wrap.classList.add('is-filled');
      // Clear any error state on file picker
      wrap.classList.remove('has-error');
    } else {
      textEl.textContent = defaultText;
      wrap.classList.remove('is-filled');
    }
  });
})();

/* ===== FORM VALIDATION =====
   Runs on submit (capture phase) to block submission before any
   theme-level cart drawer JS can intercept the form.
*/
(function() {
  var form = document.querySelector('.cta-bmc__form');
  if (!form) return;

  var styleField = form.querySelector('#cta-bmc-style');
  var fileField = form.querySelector('#cta-bmc-file');
  var termsField = form.querySelector('#cta-bmc-terms');
  var fileWrap = fileField ? fileField.closest('.cta-bmc__file-wrap') : null;

  function showError(field, message) {
    clearError(field);
    var errorEl = document.createElement('p');
    errorEl.className = 'cta-bmc__error';
    errorEl.textContent = message;
    errorEl.setAttribute('data-cta-bmc-error', '');

    // Insert error after the field's container
    var anchor = field;
    if (field === fileField && fileWrap) {
      anchor = fileWrap;
      fileWrap.classList.add('has-error');
    } else if (field === termsField) {
      anchor = field.closest('.cta-bmc__terms') || field;
      anchor.classList.add('has-error');
    } else {
      field.classList.add('has-error');
    }
    anchor.parentNode.insertBefore(errorEl, anchor.nextSibling);
  }

  function clearError(field) {
    var anchor = field;
    if (field === fileField && fileWrap) {
      fileWrap.classList.remove('has-error');
      anchor = fileWrap;
    } else if (field === termsField) {
      var termsWrap = field.closest('.cta-bmc__terms');
      if (termsWrap) termsWrap.classList.remove('has-error');
      anchor = termsWrap || field;
    } else {
      field.classList.remove('has-error');
    }
    var existing = anchor.parentNode.querySelector('[data-cta-bmc-error]');
    if (existing && existing.previousSibling === anchor) {
      existing.remove();
    }
  }

  function clearAllErrors() {
    [styleField, fileField, termsField].forEach(function(f) {
      if (f) clearError(f);
    });
  }

  // Live-clear errors as user fixes them
  if (styleField) {
    styleField.addEventListener('input', function() {
      if (styleField.value.trim()) clearError(styleField);
    });
  }
  if (termsField) {
    termsField.addEventListener('change', function() {
      if (termsField.checked) clearError(termsField);
    });
  }

  function validate(e) {
    clearAllErrors();
    var errors = [];

    if (styleField && !styleField.value.trim()) {
      showError(styleField, 'Please tell us your preferred style and finish.');
      errors.push(styleField);
    }

    if (fileField && (!fileField.files || fileField.files.length === 0)) {
      showError(fileField, 'Please upload your IKEA or Bunnings kitchen plan PDF.');
      errors.push(fileField);
    } else if (fileField && fileField.files[0]) {
      var f = fileField.files[0];
      // 20MB cap (Shopify limit)
      if (f.size > 20 * 1024 * 1024) {
        showError(fileField, 'File is over 20MB. Please compress and try again.');
        errors.push(fileField);
      }
      // Loose extension check (accept attribute filters most cases)
      if (!/\.pdf$/i.test(f.name)) {
        showError(fileField, 'Please upload a PDF file.');
        errors.push(fileField);
      }
    }

    if (termsField && !termsField.checked) {
      showError(termsField, 'Please accept the Terms & Conditions to continue.');
      errors.push(termsField);
    }

    if (errors.length > 0) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Scroll to and focus the first error
      var first = errors[0];
      try {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() {
          if (first.focus) first.focus({ preventScroll: true });
        }, 300);
      } catch (err) {
        if (first.focus) first.focus();
      }
      return false;
    }
    return true;
  }

  // Capture phase = runs BEFORE any theme-level submit handlers
  form.addEventListener('submit', validate, true);

  // Backup: also block on the submit button click in capture phase,
  // in case the theme replaces the form's submit behavior entirely
  var submitBtn = form.querySelector('.cta-bmc__submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function(e) {
      // Let the form's submit event handle validation;
      // only intervene if click triggers something else
      if (!validate(e)) {
        return false;
      }
    }, true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-3');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();
})();
